import React from 'react';
import Settings from './Settings';
import ContractCompliance from './ContractCompliance';

const ContractComplianceWidget = props => (
  <ContractCompliance
    timeUnit={props.time_unit}
    tablePeriodType={props.table_period_type}
    carouselPeriodType={props.carousel_period_type}
    dashboardAPIManager={props.dashboardAPIManager}
    showCarousel={props.show_carousel}
    showBreakdown={props.show_breakdown}
  />
);

Object.assign(ContractComplianceWidget, {
  SettingsContent: Settings,
  defaultSettings: {
    time_unit: 'shift',
    table_period_type: 'year',
    carousel_period_type: 'week',
    show_carousel: true,
    show_breakdown: true
  }
});

export default ContractComplianceWidget;
